import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import authenticate from '@/store/authenticate';
import chat from '@/store/chat';


Vue.use(Vuex);

export default new Vuex.Store({
  state : {
    Uid: null,
    user: null,
    returnUrl: null
  },
  getters : {
    user (state) {
      return state.user;
    },
    returnUrl(state) {
      return state.returnUrl;
    },
    isAuthenticated (state) {
      return state.Uid !== null;
    },
    headerState: () => {
      let result = router.currentRoute.query.header ? parseInt(router.currentRoute.query.header) : 1;
      return result == 1;
    },
    footerState: () => {
      let result = router.currentRoute.query.footer ? parseInt(router.currentRoute.query.footer) : 1;
      return result == 1;
    },
    titleState: () => {
      let result = router.currentRoute.query.title ? parseInt(router.currentRoute.query.title) : 1;
      return result == 1;
    }
  },
  mutations :{
    authUser (state, userData) {
      state.Uid = userData.Uid;
      state.user = userData;
    },
    storeUser (state, user) {
      state.user = user;
    },
    clearAuthData (state) {
      state.Uid = null;
      state.use = null;
    },
    setReturnUrl(state, url){
      state.returnUrl = url;
    },
    clearReturnUrl(state){
      state.returnUrl = null;
    }
  },
  actions : {
    signup ({commit, dispatch}, authData) {
      commit('authUser', {
        Uid: authData.Uid
      });

      localStorage.setItem('Uid', authData.Uid);
      localStorage.setItem('user', JSON.stringify(authData));

      dispatch('storeUser', authData);
      //dispatch('setLogoutTimer', authData.expiresIn);
    },
    login ({commit}, authData) {

      localStorage.setItem('Uid', authData.Uid);
      localStorage.setItem('user', JSON.stringify(authData));

      commit('authUser', authData);
      commit('storeUser', authData);

    },
    logout ({commit}) {
      commit('clearAuthData');

      localStorage.removeItem('Uid');
      localStorage.removeItem('user');
    },
    fetchUser ({commit}) {
      let user = localStorage.getItem('user');
      if(user)
        commit('authUser', JSON.parse(user));
    },
    fetchReturnUrl({commit}) {
      let url = localStorage.getItem('ReturnUrl');
      if (url)
        commit('setReturnUrl', url);
    },
    setReturnUrl({ commit }, url) {
      localStorage.setItem('ReturnUrl', url);
      commit('setReturnUrl', url);
    },
    clearReturnUrl({ commit}){
      localStorage.removeItem('ReturnUrl');
      commit('clearReturnUrl');
    }

  }
  // modules : {
  //   authenticate
  // }
});
